import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';

const SelectOption = /*#__PURE__*/ forwardRef(({ id: externalId, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, value, children }, ref)=>{
    return /*#__PURE__*/ jsx("option", {
        ref: ref,
        lang: lang,
        id: externalId,
        className: className,
        "data-testid": dataTestId,
        value: value,
        children: children
    });
});
SelectOption.displayName = 'SelectOption';

export { SelectOption };
